import { find } from 'lodash'
import { getAllTranslations, getJsonData, getOpenGraphData } from './_api'

const getTranslations = ({ commit }) => {
    return new Promise((resolve, reject) => {
        getAllTranslations({ lang: 'nl' })
        .then(result => {
            return resolve(result)
        })
        .catch(error => {
            const message = error.response.data.message
            reject(new Error(message))
        })
    })
}

const getJson = ({ commit }, { filename }) => {
    return new Promise((resolve, reject) => {
        getJsonData({ filename })
          .then(result => {
              return resolve(result)
          })
          .catch(error => {
              const message = error.response.data.message
              reject(new Error(message))
          })
    })
}

const openGraphData = ({ }, { href }) => {
    return new Promise((resolve, reject) => {
        getOpenGraphData({ href })
          .then(result => {
              return resolve(result)
          })
          .catch(error => {
              const message = error.response.data.message
              reject(new Error(message))
          })
    })
}

const initiatePuzzle = ({ commit, getters }, { puzzle }) => {
    commit('setCurrentPuzzle', { puzzle })
    commit('setFoundWordIdsFromLocalStorage', { puzzle })
    commit('shuffleBonusCells', { puzzle })
    commit('setTimerFromLocalStorage', { timerId: getters.puzzleTimerId })
    commit('setActiveWordIndex', { activeWordIndex: null })
}

const resetPuzzle = ({ commit, getters }) => {
    commit('resetFoundWordIds')
    commit('resetTimer', { timerId: getters.puzzleTimerId })
}

const finishCellSelection = ({ state, commit }) => {
    const selectedCells = state.gridSettings.selectedCells
    if (selectedCells.length) {
        const selectedCellIds = selectedCells.map(item => item.id)
        const word_id = selectedCells[0].word_id
        const word = find(state.currentPuzzle.words, item => item.id === word_id)
        const correctCellChain = word.cells.map(item => item.id)

        if (!word.is_bonus && JSON.stringify(selectedCellIds) === JSON.stringify(correctCellChain)) {
            commit('addFoundWordId', { word_id })
            commit('setFoundWordIdToAnimate', { word_id })
        }
    }

    commit('setIsSelectingAnswer', { isSelectingAnswer: false })
    commit('resetSelectedCells')
}

const setSnackar = ({ commit }, { module, subform, isForm, notification }) => {
    commit('setNotification', { module, subform, isForm, notification })

    setTimeout(() => {
        commit('resetNotification', { module, subform, isForm })
    }, 5000)
}

// Export
export default {
    getTranslations,
    getJson,
    openGraphData,
    initiatePuzzle,
    resetPuzzle,
    finishCellSelection,
    setSnackar
}
